//

import { useState } from "react";
import { URL_CONSTANTS } from "../../axios/urlLinksThemes";
import { I_EXTERNAL_PAGES } from "../../shared/commonUtils";
import { httpPost } from "../../axios/axiosUtils";
import {
  getBussinessData,
  getUserPrefersLang,
} from "../../shared/helpersMethod";
import { useNavigate } from "react-router-dom";

const useGetExternalPages = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const bussinessData = getBussinessData();
  const [pageInfo, setPageInfo] = useState<I_EXTERNAL_PAGES>();
  const userLanguage = getUserPrefersLang();
  var attempt = 0;
  const queryParamLang = `?lang=${userLanguage}`;
  const getPageBySlug = async (pageSlug: string | undefined) => {
    console.log("called");
    setLoading(true);
    // +`${userLanguage !== null ? queryParamLang : ''}`
    try {
      const res = await httpPost(
        URL_CONSTANTS.get("URL_EXTERNAL_PAGES")! + `${pageSlug}`,
        { lang: userLanguage },
        {},
        bussinessData.accessToken
      );
      setLoading(false);
      if (res.type == "error" && res.token === "expired" && attempt < 2) {
        setTimeout(() => {
          getPageBySlug(pageSlug);
          attempt = attempt + 1;
        }, 1000);

        return;
      }
      if (res.type != "error") {
        setPageInfo(res.data);
      } else {
        if (res.token !== "expired") {
          navigate("/404");
        }
      }
    } catch (error: any) {
      console.log(error.message);
      setLoading(false);
    }
  };

  return {
    getPageBySlug,
    pageInfo,
    loading,
  };
};
export default useGetExternalPages;
